import { useState } from 'react'

import PropTypes from 'prop-types'
import { Autocomplete } from '@material-ui/lab'
import { TextField, CircularProgress } from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'

import { useFetch } from 'hooks'

import helpers from 'helpers'
import * as service from 'service'

const OrganizationTypeAndSearchInput = ({
  setOrganization = () => {},
  kind = undefined,
  handleChangeOrganization = () => {},
  label = 'Grupo Advisor',
  fieldName = 'organizationId',
  multiple = false,
}) => {
  const [organizationInputValue, setOrganizationInputValue] = useState('')

  const { control, errors } = useFormContext()

  const { instructionsText } = helpers.organizations.typeAndSearch

  const onChangeOrganization = (data) => {
    setOrganization(data)
    handleChangeOrganization()
  }

  const handleTypeOrganizationsInput = (e) => {
    setOrganizationInputValue(e.target.value)
  }

  const mountOrganizationParams = () => {
    return {
      name: organizationInputValue,
      minimal: true,
      perPage: 1000 * 1000,
      kind,
    }
  }

  const { response, isStillLoading } = useFetch(
    service.backoffice.organizations.get,
    mountOrganizationParams(),
    [organizationInputValue],
    organizationInputValue.length >= 3,
  )

  const organizations = response?.data?.organizations || []

  return (
    <Controller
      control={control}
      name={fieldName}
      onChange={([, data]) => {
        onChangeOrganization(data)
        return data
      }}
      mode="onBlur"
      as={
        <Autocomplete
          multiple={multiple}
          options={organizations}
          getOptionLabel={(option) => option?.name || ''}
          getOptionSelected={(option, value) =>
            option?.id === value?.id || null
          }
          disableClearable
          noOptionsText={instructionsText({ organizationInputValue })}
          loading={isStillLoading}
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!errors?.[fieldName]}
              onChange={handleTypeOrganizationsInput}
              helperText={errors?.[fieldName]?.message || errors?.[fieldName]}
              label={label}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isStillLoading && (
                      <CircularProgress color="primary" size={20} />
                    )}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      }
    />
  )
}

OrganizationTypeAndSearchInput.propTypes = {
  control: PropTypes.object,
  errors: PropTypes.object,
  setOrganization: PropTypes.func,
  kind: PropTypes.string,
  handleChangeOrganization: PropTypes.func,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  multiple: PropTypes.bool,
}

export default OrganizationTypeAndSearchInput
